/* HELIX — minimal behavior layer. No frameworks, no jQuery.
   1. Reveal-on-scroll for .hx-reveal
   2. Header: mobile menu + solid-on-scroll
   3. Dropdown toggles (aria-expanded synced)
   4. Cart count refresh after add-to-cart (product form posts via fetch)
*/
(function () {
  "use strict";

  /* 1 ── reveal */
  function initReveal() {
    var els = document.querySelectorAll(".hx-reveal:not(.in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2 ── header */
  function initHeader() {
    var header = document.querySelector("[data-hx-header]");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("is-scrolled", window.scrollY > 8);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
    var burger = document.querySelector("[data-hx-burger]");
    var menu = document.getElementById("hx-mobile-menu");
    if (burger && menu) {
      var close = function () {
        menu.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
        document.documentElement.style.overflow = "";
        setTimeout(function () { if (!menu.classList.contains("is-open")) menu.hidden = true; }, 300);
      };
      burger.addEventListener("click", function () {
        if (menu.classList.contains("is-open")) { close(); return; }
        menu.hidden = false;
        requestAnimationFrame(function () { menu.classList.add("is-open"); });
        burger.setAttribute("aria-expanded", "true");
        document.documentElement.style.overflow = "hidden";
      });
      // close on: a nav link, the explicit close button, or a tap on the scrim
      // (the overlay sits above the header, so the burger itself is not tappable while open)
      menu.addEventListener("click", function (e) {
        if (e.target.closest("a") || e.target.closest("[data-hx-menu-close]") || !e.target.closest(".hx-mobile__panel")) close();
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && menu.classList.contains("is-open")) close(); });
    }
  }

  /* 3 ── dropdowns */
  function initDropdowns() {
    var items = document.querySelectorAll("[data-hx-dropdown]");
    var closeAll = function (except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove("is-open");
        var t = item.querySelector("[data-hx-dropdown-toggle]");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    };
    items.forEach(function (item) {
      var toggle = item.querySelector("[data-hx-dropdown-toggle]");
      if (!toggle) return;
      toggle.addEventListener("click", function () {
        var opening = !item.classList.contains("is-open");
        closeAll(item);
        item.classList.toggle("is-open", opening);
        toggle.setAttribute("aria-expanded", opening ? "true" : "false");
      });
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-hx-dropdown]")) closeAll();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  /* 4 ── ajax add-to-cart */
  function initCart() {
    document.querySelectorAll("form[data-hx-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        var label = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute("data-adding-text") || "Adding…"; }
        fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll("[data-hx-cart-count]").forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle("has-items", cart.item_count > 0);
            });
            if (btn) { btn.textContent = btn.getAttribute("data-added-text") || "Added ✓"; }
            var live = document.getElementById("hx-live");
            if (live) live.textContent = "Item added to cart. Cart has " + cart.item_count + " item" + (cart.item_count === 1 ? "" : "s") + ".";
            setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600);
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            form.submit(); /* graceful fallback to full-page add */
          });
      });
    });
  }

  function init() { initReveal(); initHeader(); initDropdowns(); initCart(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
